import createLogger from 'vuex/logger';

var result = [];
if (__DEV__) {
	result.push(createLogger());
}

export default result;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/vuex/middlewares.js
 **/